/**
 * Retrieves the cookie at the provided cookie name
 * @param {string} name Cookie's name
 * @returns {string | null} String containing the whole cookie value
 */
export const getCookie = (name) => {
    const cookieFound = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return cookieFound ? cookieFound[2] : null;
};

/**
 * Sets the cookie with the provided name and value
 * @param {string} name
 * @param {string} value The contente of the cookie
 * @param {number=} days Defaults to 1000 days
 */
export const setCookie = (name, value, days = 1000) => {
    const now = new Date();

    now.setTime(now.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + '=' + value + ';path=/;expires=' + now.toUTCString();
};

/**
 * Sets the cookie with the provided name and value
 * @param {string} name
 * @param {string} value The contente of the cookie
 * @param {number=} days Defaults to 1000 days
 */
export const setCookieCorriere = (name, value, days = 1000) => {
    const now = new Date();

    now.setTime(now.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name}=${value}; path=/; domain=.corriere.it; expires=${now.toUTCString()};`;
};

/**
 * Deletes a cookie at the provided cookie name
 * @param {string} name Cookie's name
 */
export const deleteCookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
